/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 2025/11/19 15:37
 * @update 2025/11/19 15:37
 * @file src/actions/general-actions.js
 */
import Api from '../services/api.js';

export function loadAttachments(params, cb) {
    return (_dispatch) => {
        Api.put('/attachment/get', params)
        .then(result => {
            if (result && result.code && result.code !== 200) {
                if (cb) cb(result, null);
            } else {
                if (cb) cb(null, result.data);
            }
        });
    };
}

export function addAttachments(params, cb) {
    return (_dispatch) => {
        Api.put('/attachment/add', params)
        .then(result => {
            if (result && result.code && result.code !== 200) {
                if (cb) cb(result, null);
            } else {
                if (cb) cb(null, result.data);
            }
        });
    };
}

export function removeAttachments(params, cb) {
    return (_dispatch) => {
        Api.delete('/attachment/remove', params)
        .then(result => {
            if (result && result.code && result.code !== 200) {
                if (cb) cb(result, null);
            } else {
                if (cb) cb(null, result.data);
            }
        });
    };
}